import axios from 'axios'; // 引入axios
axios.defaults.timeout = 10000;
import { ElMessage } from 'element-plus'
import QS from 'qs';

// 请求拦截器
axios.interceptors.request.use(config => {
    // 每次发送请求之前判断是否存在token        
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登陆情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断 
    const token = localStorage.getItem('token');
    token && (config.headers.Authorization = token);
    return config;
},
    error => {
        return Promise.error(error);
    })
// 响应拦截器
axios.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
        // 否则的话抛出错误
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码    
    // 然后根据返回的状态码进行一些操作，例如登陆过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {
        if (error.response.status) {
            switch (error.response.status) {

                // 401: 未登陆
                // 未登陆则跳转登陆页面，并携带当前页面的路径
                // 在登陆成功后返回当前页面，这一步需要在登陆页操作。                
                case 401:
                    if (localStorage.getItem('token')) {
                        localStorage.removeItem('role')
                        localStorage.removeItem('token')
                        localStorage.removeItem('userId')
                        localStorage.removeItem('userName')
                        localStorage.removeItem('expireDate')
                        error.message = '登陆过期，请重新登陆！'
                    } else {
                        error.message = '请登陆！'
                    }
                    setTimeout(() => {
                        this.$router.push('/login')
                    }, 200)
                    break;

                // 403 token过期
                // 登陆过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登陆页面                
                case 403:
                    error.message = '登陆过期，请重新登陆'
                    // 清除token
                    localStorage.removeItem('role')
                    localStorage.removeItem('token')
                    localStorage.removeItem('userId')
                    localStorage.removeItem('userName')
                    localStorage.removeItem('expireDate')
                    // 跳转登陆页面，并将要浏览的页面fullPath传过去，登陆成功后跳转需要访问的页面 
                    setTimeout(() => {
                        // window.location.href = '/login'
                        this.$router.push('/login')
                    }, 1000);
                    break;

                // 404请求不存在
                case 404:
                    error.message = '网络请求不存在'
                    setTimeout(() => {
                        window.location.href = '/#/login'
                        this.$router.push('/login')
                    }, 200)
                    break;

                case 500:
                    console.log(2323)
                    error.message = '登陆过期，请重新登陆'
                    // 清除token
                    localStorage.removeItem('role')
                    localStorage.removeItem('token')
                    localStorage.removeItem('userId')
                    localStorage.removeItem('userName')
                    localStorage.removeItem('expireDate')
                    // 跳转登陆页面，并将要浏览的页面fullPath传过去，登陆成功后跳转需要访问的页面 
                    setTimeout(() => {
                        // window.location.href = '/login'
                        this.$router.push('/login')
                    }, 200);
                    break;

                // 其他错误，直接抛出错误提示
                default:
                    error.message = error.response.data.message
            }
            ElMessage(error.message)
            return Promise.reject(error.response);
        }
    }
);

/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
//测试环境
// export const REQUEST_API = 'https://api-stage.aigeyun.cn'
export const REQUEST_API = 'https://api.aigeyun.cn'
// export const SOURCE_API = 'https://res-stage.aigeyun.cn'
export const CHECK_SOURCE = 'https://res.aigeyun.cn'
export const SOURCE_API = 'https://res.aigeyun.cn'